import { useLocation } from 'react-router-dom';
import { splitLangPath, localizedPath } from '../i18n/routing';

/**
 * Devolve uma função que prefixa um caminho interno com o idioma atual.
 *
 * Sem isto, clicar em "PixRow" a partir de `/es` levaria para `/pixrow` e
 * jogaria o visitante de volta ao português no meio da navegação.
 */
export default function useLocalizedPath() {
  const { pathname } = useLocation();
  const { lang } = splitLangPath(pathname);
  return (rest) => localizedPath(rest, lang);
}
